import PanResponder from './PanResponder'
import ResponderEventPlugin from './ResponderEventPlugin'
import { injectEventPluginsByName } from 'react-dom/unstable-native-dependencies'

// Add responder events
injectEventPluginsByName({ ResponderEventPlugin })

export default PanResponder